/**
 * 资方编码
 * 说明：资方接入形式有多种，均为“半流程”，但页面承载方式不同：
 * - API + 我方页面
 * - API + 三方页面（跳转三方页或 APP 下载引导）
 */

export enum MerchantCode {
  // 涉及我方页面接入的资方
  LIANG_HUA_PAI = "1310552102", // 量化派
  JING_YIN_RONG = "1310552103", // 京银融
  REN_PIN = "1310552104", // 人品
  HENG_XIAO_HUA = "1310552105", // 恒小花
  NI_WO_DAI = "1310552106", // 你我贷
  LIAN_RONG = "1310552107", // 联融
  LE_XIANG_RONG = "1310552108", // 乐享融
  WEI_XIANG_HUA = "1310552109", // 唯享花
  HE_XIAO_BAO = "1310552110", // 禾小包

  // 涉及三方页面接入的资方
  HE_XIAO_BAO_CASH = "1310552160", // 禾小包现金贷
  YUAN_XIAO_HUA_MALL = "1310552115", // 源小花商城
  YUAN_XIAO_HUA = "1310552114", // 源小花
  LU_YOU_XUAN = "1310552111", // 鹿优选
  KA_NIU = "1310552112", // 卡牛
  RUI_HE = "1310552142", // 锐合
  HENG_XIN = "1310552143", // 恒信
  JIN_CAI_DAI = "1310552144", // 金彩贷
  YUN_DOU_HUA = "1310552145", // 芸豆花
  KE_DAI_QIAN_BAO = "1310552170", // 可贷钱包
  FEN_ZHUAN = "1310552180", // 分转
  KE_XIANG_DAI = "1310552171", // 可享贷
  ZHI_LIAN_RONG = "1310552181", // 智联融
  MAI_BEI = "1310552182", // 买呗
  XIN_YUAN_HUA = "1310552184", // 鑫源花
  DUO_JIN_YOU_XUAN = "1310552185", // 多金优选
  MEI_XIN = "1310552186", // 美信
  SHAN_JIE_HUA = "1310552189", // 闪接花
  LIANG_HUA_PAI_HALF = "1310552187", // 量化派半流程
  JING_XIANG_GOU = "1310552188", // 京享购
}

/**
 * 权益类资方列表
 * 说明：这些资方需要跳转到权益类页面（loanBenefit / billDetailBenefit）
 */
export const BENEFIT_MERCHANTS: Set<string> = new Set([
  MerchantCode.REN_PIN, // 人品
  MerchantCode.LIAN_RONG, // 联融
  MerchantCode.LE_XIANG_RONG, // 乐享融
  MerchantCode.WEI_XIANG_HUA, // 唯享花
  MerchantCode.HE_XIAO_BAO, // 禾小包
]);

/**
 * 商城类（第三方页面）资方列表
 * 说明：商城类资方接入形式为“半流程”，需要通过API获取三方页面链接
 * - API + 三方页面（跳转三方页或 APP 下载引导）
 */
export const THIRD_PARTY_PAGE_MERCHANTS: Set<string> = new Set([
  MerchantCode.HE_XIAO_BAO_CASH, // 禾小包现金贷
  // MerchantCode.YUAN_XIAO_HUA_MALL, // 源小花商城
  MerchantCode.YUAN_XIAO_HUA, // 源小花
  MerchantCode.LU_YOU_XUAN, // 鹿优选
  MerchantCode.KA_NIU, // 卡牛
  MerchantCode.RUI_HE, // 锐合
  MerchantCode.HENG_XIN, // 恒信
  MerchantCode.JIN_CAI_DAI, // 金彩贷
  MerchantCode.YUN_DOU_HUA, // 芸豆花
  MerchantCode.KE_DAI_QIAN_BAO, // 可贷钱包
  MerchantCode.FEN_ZHUAN, // 分转
  MerchantCode.KE_XIANG_DAI, // 可享贷
  MerchantCode.ZHI_LIAN_RONG, // 智联融
  MerchantCode.MAI_BEI, // 买呗
  MerchantCode.XIN_YUAN_HUA, // 鑫源花
  MerchantCode.DUO_JIN_YOU_XUAN, // 多金优选
  MerchantCode.MEI_XIN, // 美信
  MerchantCode.SHAN_JIE_HUA, // 闪接花
  MerchantCode.LIANG_HUA_PAI_HALF, // 量化派半流程
  MerchantCode.JING_XIANG_GOU, // 京享购
]);
